// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RollbackOutlinedSvg from "@fishx/icons-svg/es/asn/RollbackOutlined";
import FishxIcon from '../components/FishxIcon';

var RollbackOutlined = function RollbackOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RollbackOutlinedSvg
  }));
};

RollbackOutlined.displayName = 'RollbackOutlined';
export default React.forwardRef(RollbackOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RollbackOutlined.js
// module id = 4044
// module chunks = 0